"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'imgBottom',
  props: {
    datas: Object
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || ''
    };
  },
  computed: {
    reqPath: function reqPath() {
      return this.resPath;
    },
    // 计算轮播间隔时间，单位毫秒
    carouselInterval: function carouselInterval() {
      return this.datas.interval ? this.datas.interval * 1000 : 3000;
    },
    // 图片自定义宽高样式（0 表示自适应）
    imgSizeStyle: function imgSizeStyle() {
      var style = {};
      if (this.datas.imgWidth) {
        // 自定义宽度，CSS max-width:100% 保证不超出容器
        style.width = this.datas.imgWidth + 'px';
      }
      if (this.datas.imgHeight) {
        style.height = this.datas.imgHeight + 'px';
      }
      return style;
    }
  },
  methods: {}
};